import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./ListRow.module.scss";

/**
 * Card-style browse row for activity / session lists.
 * Prefer Table for editable dense grids (POAM, admin registers).
 */
export function ListRow({
  badge = null,
  title,
  subtitle = null,
  meta = null,
  actions = null,
  onClick = null,
  rail = true,
  className,
  ...rest
}) {
  const interactive = typeof onClick === "function";

  const onKeyDown = (e) => {
    if (!interactive) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <div
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      className={cn(
        styles.row,
        rail && styles.rail,
        interactive && styles.interactive,
        className
      )}
      onClick={onClick}
      onKeyDown={onKeyDown}
      {...rest}
    >
      {badge ? <div className={styles.badge}>{badge}</div> : null}
      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      </div>
      {meta ? <div className={styles.meta}>{meta}</div> : null}
      {actions ? (
        <div
          className={styles.actions}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}

ListRow.propTypes = {
  badge: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  meta: PropTypes.node,
  actions: PropTypes.node,
  onClick: PropTypes.func,
  rail: PropTypes.bool,
  className: PropTypes.string,
};

export default ListRow;
